module.exports = {
    apiServerUrl: 'https://api.testing.amplement.com',
    publicHostname: 'https://app.testing.my-collaborate.com',
    websocketHostname: 'https://ws.testing.amplement.com',
    debug: true,
    logLevel: 'debug',
    logFilter: 'myc:*'
};
